import { Toast } from '@/utils/index';
import { showModal } from "@/views/repairprogress/serve/modal";

export const handleDeleteCommon = (fn, id, updateFn) => {
    return new Promise((resolve, reject) => {
        showModal({
            title: "提示",
            toastText: "确认删除？",
            success: () => {
                fn([id])
                    .then((res) => {
                        Toast(res.code === 200 ? "success" : "warning", res.message, 3);
                        updateFn();
                        resolve('ok')
                    })
                    .catch((err) => {
                        reject(err)
                    });
            },
        });
    });
}
